const API = {
    BASE_URL: 'https://charts.lockedtrade.com/auth/api/',
    SEND_EMAIL_URL: 'https://charts.lockedtrade.com/auth/api/send-email/',
}

export default API;